import { Navigate, Route, Routes } from "react-router-dom";
import { LoginPage } from "@/pages/LoginPage";
import { AuthHandoffPage } from "@/pages/AuthHandoffPage";
import { ModuleRelayPage } from "@/pages/ModuleRelayPage";
import { ModuleLauncherPage } from "@/pages/ModuleLauncherPage";
import { PlatformCommercialPage } from "@/pages/PlatformCommercialPage";
import { AccessDeniedPage } from "@/pages/AccessDeniedPage";
import { SuiteLogoutPage } from "@/pages/SuiteLogoutPage";
import { ProtectedRoute } from "./ProtectedRoute";
import { SuiteHomeRedirect } from "./SuiteHomeRedirect";
import { PlatformHubRoute } from "./PlatformHubRoute";
import { PlatformLayout } from "@/components/PlatformLayout";
import { PlatformIndexRedirect } from "@/pages/platform/PlatformIndexRedirect";
import { PlatformSchoolsPage } from "@/pages/platform/PlatformSchoolsPage";
import { PlatformSchoolDetailPage } from "@/pages/platform/PlatformSchoolDetailPage";
import { PlatformUsersHubPage } from "@/pages/platform/PlatformUsersHubPage";
import { PlatformSettingsPage } from "@/pages/platform/PlatformSettingsPage";
import { routes } from "./all_routes";

export function AppRouter() {
  return (
    <Routes>
      <Route path={routes.login} element={<LoginPage />} />
      <Route path="/auth/handoff" element={<AuthHandoffPage />} />
      <Route path="/auth/relay" element={<ModuleRelayPage />} />
      <Route path="/auth/logout" element={<SuiteLogoutPage />} />
      <Route
        path={routes.modules}
        element={
          <ProtectedRoute>
            <ModuleLauncherPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={routes.platform}
        element={
          <PlatformHubRoute>
            <PlatformLayout />
          </PlatformHubRoute>
        }
      >
        <Route index element={<PlatformIndexRedirect />} />
        <Route path="schools" element={<PlatformSchoolsPage />} />
        <Route path="schools/:slug" element={<PlatformSchoolDetailPage />} />
        <Route path="users" element={<PlatformUsersHubPage />} />
        <Route path="commercial" element={<PlatformCommercialPage />} />
        <Route path="settings" element={<PlatformSettingsPage />} />
      </Route>
      <Route
        path={routes.accessDenied}
        element={
          <ProtectedRoute>
            <AccessDeniedPage />
          </ProtectedRoute>
        }
      />
      <Route path="/" element={<SuiteHomeRedirect />} />
      <Route path="*" element={<Navigate to={routes.login} replace />} />
    </Routes>
  );
}
